/**
 * Autogenerated file don't modify
 */
(function () {
(function (swiper) {
    'use strict';

    MoyaComponents.register('weather.carousel', function (el) {
        Carousel.handleEventlist(el);
    });
    var Carousel = /** @class */ (function () {
        function Carousel() {
        }
        Carousel.handleEventlist = function (el) {
            if (el.classList.contains('swiper-container')) {
                return;
            }
            el.classList.add('swiper-container');
            el.querySelector('.weatherMulti').classList.add('swiper-wrapper');
            el.querySelectorAll('.weatherData').forEach(function (event) {
                event.classList.add('swiper-slide');
            });
            //Create navigation
            var nav = document.createElement('div');
            nav.classList.add('swiper-nav');
            var prev = document.createElement('button');
            prev.classList.add('prev');
            prev.setAttribute('aria-label', 'Prev');
            prev.setAttribute('type', 'button');
            prev.setAttribute('role', 'presentation');
            nav.append(prev);
            var next = document.createElement('button');
            next.classList.add('next');
            next.setAttribute('aria-label', 'Next');
            next.setAttribute('type', 'button');
            next.setAttribute('role', 'presentation');
            nav.append(next);
            el.prepend(nav);
            MoyaLoader.all([
                'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css',
                'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js',
            ]).then(function () {
                new swiper.Swiper('#' + el.id, {
                    createElements: true,
                    autoplay: {
                        delay: 10000,
                    },
                    spaceBetween: 20,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: '.swiper-nav .next',
                        prevEl: '.swiper-nav .prev',
                    },
                    loop: true,
                });
            });
        };
        return Carousel;
    }());

}(window));
typeof tsBuild === 'function' && tsBuild();})();
